import { useEffect, useState } from "react";

import {
    useNavigate,
    useSearchParams,
} from "react-router-dom";

import {
    doc,
    getDoc,
    setDoc,
} from "firebase/firestore";

import { db } from "../firebase/firebase";

export default function IndividualView() {

    const navigate = useNavigate();

    const [searchParams] =
        useSearchParams();

    const id =
        searchParams.get("id");

    const [loading, setLoading] =
        useState(true);

    const [saving, setSaving] =
        useState(false);

    const [item, setItem] =
        useState({
            type: "",
            title: "",
            id: "",
            category: "",

            icon: "",
            logo: "",
            banner: "",

            shortDescription: "",

            levels: [],

            curriculum: [],

            projects: [],

            outcomes: [],

            seo: {
                seoTitle: "",
                seoDescription: "",
                seoKeywords: [],
            },
        });

    /* ---------------- FETCH ---------------- */
    useEffect(() => {

        fetchItem();

    }, []);

    const fetchItem = async () => {

        try {

            const snap = await getDoc(
                doc(
                    db,
                    "individual",
                    "allData"
                )
            );

            if (snap.exists()) {

                const allItems =
                    snap.data().items ||
                    [];

                const foundItem =
                    allItems.find(
                        (i) =>
                            i.id === id
                    );

                if (foundItem) {

                    setItem(foundItem);

                } else {

                    alert(
                        "Item not found"
                    );
                }
            }

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);
        }
    };

    /* ---------------- SAVE ---------------- */
    const handleSave = async () => {

        try {

            setSaving(true);

            const ref = doc(
                db,
                "individual",
                "allData"
            );

            const snap =
                await getDoc(ref);

            if (!snap.exists()) {

                return alert(
                    "Document missing"
                );
            }

            const allItems =
                snap.data().items ||
                [];

            const updatedItems =
                allItems.map(
                    (i) => {

                        if (
                            i.id === id
                        ) {
                            return item;
                        }

                        return i;
                    }
                );

            await setDoc(ref, {
                items: updatedItems,
            });

            alert("Updated ✅");

        } catch (err) {

            console.error(err);

            alert("Failed ❌");

        } finally {

            setSaving(false);
        }
    };

    /* ---------------- ARRAY HELPERS ---------------- */
    const updateArray = (
        field,
        index,
        value
    ) => {

        const updated = [
            ...(item[field] || []),
        ];

        updated[index] = value;

        setItem({
            ...item,
            [field]: updated,
        });
    };

    const addArrayItem = (
        field
    ) => {

        setItem({
            ...item,
            [field]: [
                ...(item[field] || []),
                "",
            ],
        });
    };

    const removeArrayItem = (
        field,
        index
    ) => {

        const updated =
            item[field].filter(
                (_, i) =>
                    i !== index
            );

        setItem({
            ...item,
            [field]: updated,
        });
    };

    /* ---------------- LEVELS ---------------- */
    const addLevel = () => {

        setItem({
            ...item,
            levels: [
                ...(item.levels ||
                    []),
                {
                    title: "",
                    description: "",
                },
            ],
        });
    };

    const updateLevel = (
        index,
        key,
        value
    ) => {

        const updated = [
            ...(item.levels ||
                []),
        ];

        updated[index][key] =
            value;

        setItem({
            ...item,
            levels: updated,
        });
    };

    /* ---------------- CURRICULUM ---------------- */
    const addCurriculum =
        () => {

            setItem({
                ...item,

                curriculum: [
                    ...(item.curriculum ||
                        []),

                    {
                        module: "",
                        title: "",
                        topics: [],
                    },
                ],
            });
        };

    const updateCurriculum =
        (
            index,
            key,
            value
        ) => {

            const updated = [
                ...(item.curriculum ||
                    []),
            ];

            updated[index][key] =
                value;

            setItem({
                ...item,
                curriculum:
                    updated,
            });
        };

    const addTopic = (
        curriculumIndex
    ) => {

        const updated = [
            ...(item.curriculum ||
                []),
        ];

        updated[
            curriculumIndex
        ].topics.push("");

        setItem({
            ...item,
            curriculum:
                updated,
        });
    };

    const updateTopic = (
        curriculumIndex,
        topicIndex,
        value
    ) => {

        const updated = [
            ...(item.curriculum ||
                []),
        ];

        updated[
            curriculumIndex
        ].topics[topicIndex] =
            value;

        setItem({
            ...item,
            curriculum:
                updated,
        });
    };

    /* ---------------- SEO ---------------- */
    const updateSeo = (
        key,
        value
    ) => {

        setItem({
            ...item,

            seo: {
                ...item.seo,
                [key]: value,
            },
        });
    };

    if (loading) {

        return (
            <div className="text-white">
                Loading...
            </div>
        );
    }

    return (

        <div className="text-white pb-40">

            {/* HEADER */}
            <div className="flex justify-between items-center mb-8">

                <div>

                    <h1 className="text-3xl font-bold text-orange-500">
                        {item.title}
                    </h1>

                    <p className="text-slate-400 mt-1">
                        Manage technology
                    </p>

                </div>

                <button
                    onClick={() =>
                        navigate(-1)
                    }
                    className="bg-white/10 hover:bg-white/20 px-4 py-2 rounded-xl"
                >
                    Back
                </button>

            </div>

            {/* BASIC */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8">

                <h2 className="text-xl font-semibold mb-5">
                    Overview
                </h2>

                <div className="grid md:grid-cols-2 gap-5">

                    <Input
                        label="Type"
                        value={item.type}
                        onChange={(e) =>
                            setItem({
                                ...item,
                                type: e
                                    .target
                                    .value,
                            })
                        }
                    />

                    <Input
                        label="Title"
                        value={
                            item.title
                        }
                        onChange={(e) =>
                            setItem({
                                ...item,
                                title:
                                    e.target
                                        .value,
                            })
                        }
                    />

                    <Input
                        label="ID"
                        value={item.id}
                        onChange={(e) =>
                            setItem({
                                ...item,
                                id: e
                                    .target
                                    .value,
                            })
                        }
                    />

                    <Input
                        label="Category"
                        value={
                            item.category
                        }
                        onChange={(e) =>
                            setItem({
                                ...item,
                                category:
                                    e.target
                                        .value,
                            })
                        }
                    />

                </div>

                <div className="mt-5">

                    <Textarea
                        label="Short Description"
                        value={
                            item.shortDescription
                        }
                        onChange={(e) =>
                            setItem({
                                ...item,
                                shortDescription:
                                    e.target
                                        .value,
                            })
                        }
                    />

                </div>

            </div>

            {/* MEDIA */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8">

                <h2 className="text-xl font-semibold mb-5">
                    Media
                </h2>

                <div className="grid md:grid-cols-3 gap-5">

                    {[
                        "icon",
                        "logo",
                        "banner",
                    ].map(
                        (field) => (

                            <div
                                key={
                                    field
                                }
                            >

                                <Input
                                    label={
                                        field
                                    }
                                    value={
                                        item[
                                        field
                                        ]
                                    }
                                    onChange={(
                                        e
                                    ) =>
                                        setItem(
                                            {
                                                ...item,

                                                [field]:
                                                    e
                                                        .target
                                                        .value,
                                            }
                                        )
                                    }
                                />

                                {item[
                                    field
                                ] && (

                                        <img
                                            src={
                                                item[
                                                field
                                                ]
                                            }
                                            alt=""
                                            className="mt-3 rounded-xl border border-white/10 max-h-40 object-cover"
                                        />

                                    )}

                            </div>

                        )
                    )}

                </div>

            </div>

            {/* LEVELS */}
            <SectionCard
                title="Levels"
                buttonText="+ Add Level"
                onAdd={addLevel}
            >

                {(item.levels ||
                    []).map(
                        (
                            level,
                            index
                        ) => (

                            <div
                                key={
                                    index
                                }
                                className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5"
                            >

                                <Input
                                    label="Level Title"
                                    value={
                                        level.title
                                    }
                                    onChange={(
                                        e
                                    ) =>
                                        updateLevel(
                                            index,
                                            "title",
                                            e
                                                .target
                                                .value
                                        )
                                    }
                                />

                                <div className="mt-4">

                                    <Textarea
                                        label="Description"
                                        value={
                                            level.description
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            updateLevel(
                                                index,
                                                "description",
                                                e
                                                    .target
                                                    .value
                                            )
                                        }
                                    />

                                </div>

                            </div>

                        )
                    )}

            </SectionCard>

            {/* CURRICULUM */}
            <SectionCard
                title="Curriculum"
                buttonText="+ Add Module"
                onAdd={
                    addCurriculum
                }
            >

                {(item.curriculum ||
                    []).map(
                        (
                            curriculum,
                            index
                        ) => (

                            <div
                                key={
                                    index
                                }
                                className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5"
                            >

                                <div className="grid md:grid-cols-2 gap-5">

                                    <Input
                                        label="Module"
                                        value={
                                            curriculum.module
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            updateCurriculum(
                                                index,
                                                "module",
                                                e
                                                    .target
                                                    .value
                                            )
                                        }
                                    />

                                    <Input
                                        label="Title"
                                        value={
                                            curriculum.title
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            updateCurriculum(
                                                index,
                                                "title",
                                                e
                                                    .target
                                                    .value
                                            )
                                        }
                                    />

                                </div>

                                {/* TOPICS */}
                                <div className="mt-5">

                                    <h3 className="font-semibold mb-3">
                                        Topics
                                    </h3>

                                    <div className="space-y-3">

                                        {(curriculum.topics ||
                                            []).map(
                                                (
                                                    topic,
                                                    topicIndex
                                                ) => (

                                                    <input
                                                        key={
                                                            topicIndex
                                                        }
                                                        value={
                                                            topic
                                                        }
                                                        onChange={(
                                                            e
                                                        ) =>
                                                            updateTopic(
                                                                index,
                                                                topicIndex,
                                                                e
                                                                    .target
                                                                    .value
                                                            )
                                                        }
                                                        className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
                                                    />

                                                )
                                            )}

                                    </div>

                                    <button
                                        onClick={() =>
                                            addTopic(
                                                index
                                            )
                                        }
                                        className="mt-4 bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-xl"
                                    >
                                        + Add Topic
                                    </button>

                                </div>

                            </div>

                        )
                    )}

            </SectionCard>

            {/* PROJECTS */}
            <ArraySection
                title="Projects"
                field="projects"
                item={item}
                addArrayItem={
                    addArrayItem
                }
                updateArray={
                    updateArray
                }
                removeArrayItem={
                    removeArrayItem
                }
            />

            {/* OUTCOMES */}
            <ArraySection
                title="Outcomes"
                field="outcomes"
                item={item}
                addArrayItem={
                    addArrayItem
                }
                updateArray={
                    updateArray
                }
                removeArrayItem={
                    removeArrayItem
                }
            />

            {/* SEO */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8">

                <h2 className="text-xl font-semibold mb-5">
                    SEO
                </h2>

                <div className="space-y-5">

                    <Input
                        label="SEO Title"
                        value={
                            item.seo
                                ?.seoTitle
                        }
                        onChange={(e) =>
                            updateSeo(
                                "seoTitle",
                                e.target
                                    .value
                            )
                        }
                    />

                    <Textarea
                        label="SEO Description"
                        value={
                            item.seo
                                ?.seoDescription
                        }
                        onChange={(e) =>
                            updateSeo(
                                "seoDescription",
                                e.target
                                    .value
                            )
                        }
                    />

                    <ArrayEditor
                        title="SEO Keywords"
                        items={
                            item.seo
                                ?.seoKeywords ||
                            []
                        }
                        onAdd={() => {

                            updateSeo(
                                "seoKeywords",
                                [
                                    ...(item
                                        .seo
                                        ?.seoKeywords ||
                                        []),
                                    "",
                                ]
                            );

                        }}
                        onChange={(
                            index,
                            value
                        ) => {

                            const updated =
                                [
                                    ...(item
                                        .seo
                                        ?.seoKeywords ||
                                        []),
                                ];

                            updated[
                                index
                            ] = value;

                            updateSeo(
                                "seoKeywords",
                                updated
                            );

                        }}
                        onRemove={(
                            index
                        ) => {

                            const updated =
                                item.seo.seoKeywords.filter(
                                    (
                                        _,
                                        i
                                    ) =>
                                        i !==
                                        index
                                );

                            updateSeo(
                                "seoKeywords",
                                updated
                            );

                        }}
                    />

                </div>

            </div>

            {/* SAVE */}
            <div className="fixed bottom-5 right-5 z-50">

                <button
                    onClick={
                        handleSave
                    }
                    disabled={saving}
                    className="bg-orange-500 hover:bg-orange-600 px-8 py-4 rounded-2xl shadow-2xl font-semibold"
                >
                    {saving
                        ? "Saving..."
                        : "Save"}
                </button>

            </div>

        </div>
    );
}

/* ---------------- COMPONENTS ---------------- */

function Input({
    label,
    ...props
}) {

    return (

        <div>

            <label className="block mb-2 text-sm text-slate-300">
                {label}
            </label>

            <input
                {...props}
                className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
            />

        </div>
    );
}

function Textarea({
    label,
    ...props
}) {

    return (

        <div>

            <label className="block mb-2 text-sm text-slate-300">
                {label}
            </label>

            <textarea
                {...props}
                rows={5}
                className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
            />

        </div>
    );
}

function SectionCard({
    title,
    buttonText,
    onAdd,
    children,
}) {

    return (

        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8">

            <div className="flex items-center justify-between mb-5">

                <h2 className="text-xl font-semibold">
                    {title}
                </h2>

                <button
                    onClick={onAdd}
                    className="bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-xl"
                >
                    {buttonText}
                </button>

            </div>

            {children}

        </div>
    );
}

function ArrayEditor({
    title,
    items,
    onAdd,
    onChange,
    onRemove,
}) {

    return (

        <div className="space-y-4">

            <h2 className="text-lg font-semibold">
                {title}
            </h2>

            {items.map(
                (item, index) => (

                    <div
                        key={index}
                        className="flex gap-3"
                    >

                        <input
                            value={item}
                            onChange={(
                                e
                            ) =>
                                onChange(
                                    index,
                                    e.target
                                        .value
                                )
                            }
                            className="flex-1 p-3 rounded-xl bg-black/40 border border-white/20"
                        />

                        <button
                            onClick={() =>
                                onRemove(
                                    index
                                )
                            }
                            className="bg-red-600 px-4 rounded-xl"
                        >
                            Delete
                        </button>

                    </div>

                )
            )}

            <button
                onClick={onAdd}
                className="bg-orange-500 px-5 py-3 rounded-xl"
            >
                Add {title}
            </button>

        </div>
    );
}

function ArraySection({
    title,
    field,
    item,
    addArrayItem,
    updateArray,
    removeArrayItem,
}) {

    return (

        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8">

            <ArrayEditor
                title={title}
                items={
                    item[field] || []
                }
                onAdd={() =>
                    addArrayItem(
                        field
                    )
                }
                onChange={(
                    index,
                    value
                ) =>
                    updateArray(
                        field,
                        index,
                        value
                    )
                }
                onRemove={(index) =>
                    removeArrayItem(
                        field,
                        index
                    )
                }
            />

        </div>
    );
}